//  Copyright (c) 2014 Readium Foundation and/or its licensees. All rights reserved.
//
//  Redistribution and use in source and binary forms, with or without modification,
//  are permitted provided that the following conditions are met:
//  1. Redistributions of source code must retain the above copyright notice, this
//  list of conditions and the following disclaimer.
//  2. Redistributions in binary form must reproduce the above copyright notice,
//  this list of conditions and the following disclaimer in the documentation and/or
//  other materials provided with the distribution.
//  3. Neither the name of the organization nor the names of its contributors may be
//  used to endorse or promote products derived from this software without specific
//  prior written permission.

import UserManager from './user/UserManager';
import LibraryManager from './user/LibraryManager';
import AppPermissionManager from './app-permission/AppPermissionManager';
import FeatureManager from './app-permission/FeatureManager';
import LicenseManager from './user/LicenseManager';
import BookDataStoreManager from './user/BookDataStoreManager';
import NavigationManager from './user/NavigationManager';

/*var managerStore = {
        };
        
        var Managers = function(){
        };

        /!**
         *
         * @param name Name of the Manager (To retrieve all Managers use "*")
         * @param [manager] Manager to be saved
         * @returns {*}
         *!/
        Managers.prototype.manager = function (name, manager){
            if (typeof manager != "undefined"){
                if(name === "*"){
                    throw new Error("Wildcards not supported when setting");
                }
                managerStore[name] = manager;
            }else if(name === "*"){
                return managerStore;
            }else{
                return managerStore[name];
            }
        };

        var managers = new Managers();
        managers.manager("user", new UserManager());
        managers.manager("library", new LibraryManager(managers.manager("user")));

        /!*managerStore.user =  new UserManager();
        managerStore.library =  new LibraryManager(managerStore.user);*!/*/

/*var Managers = function(){
            Object.defineProperty(this, "user", {
                value: new UserManager(),
                writable: false,
                enumerable: true
            });

            Object.defineProperty(this, "library", {
                value: new LibraryManager(this.user),
                writable: false,
                enumerable: true
            });
        };


        var managers = new Managers();*/

var Managers = {};

Object.defineProperty(Managers, 'user', {
  value: new UserManager(),
  writable: false,
  enumerable: true,
});

Object.defineProperty(Managers, 'library', {
  value: new LibraryManager(Managers.user),
  writable: false,
  enumerable: true,
});

Object.defineProperty(Managers, 'license', {
  value: new LicenseManager(Managers.user),
  writable: false,
  enumerable: true,
});

Object.defineProperty(Managers, 'bookData', {
  value: new BookDataStoreManager(),
  writable: false,
  enumerable: true,
});

Object.defineProperty(Managers, 'appPermission', {
  value: new AppPermissionManager(),
  writable: false,
  enumerable: true,
});

Object.defineProperty(Managers, 'feature', {
  value: FeatureManager.getInstance(),
  writable: false,
  enumerable: true,
});

Object.defineProperty(Managers, 'navigation', {
  value: new NavigationManager(),
  writable: false,
  enumerable: true,
});

// Private functions
function removeInvalidStoreData(isbns) {
  var deletionPromises = [];
  isbns.forEach(function(isbn) {
    deletionPromises.push(
      Promise.join(
        Managers.license.deleteLicense(isbn),
        Managers.library.deleteBookInfo(isbn),
      ).then(function() {
        return determineIfBookShouldBeDeleted(isbn).then(function(toDelete) {
          if (toDelete) {
            return Managers.bookData.deleteBookData(isbn);
          }
          return toDelete;
        });
      }),
    );
  });

  return Promise.all(deletionPromises);
}

function determineIfBookShouldBeDeleted(isbn) {
  return Managers.library.getBookInfosWithIndex('isbn', isbn).then(function(bookInfos) {
    return bookInfos.length === 1;
  });
}

function getInvalidISBNsForUser(uuid) {
  return Managers.license.getAllUnkeyedLicensesWithIndex('uuid', uuid).then(function(licenses) {
    var validatePromises = licenses.map(function(licenseObj) {
      return Managers.license.validateLicense(licenseObj.isbn).then(function(isValid) {
        return { isbn: licenseObj.isbn, isValid: isValid };
      });
    });
    return Promise.all(validatePromises).then(function(statuses) {
      var isbns = statuses
        .filter(function(status) {
          return !status.isValid;
        })
        .map(function(invalidStatus) {
          return invalidStatus.isbn;
        });
      return isbns;
    });
  });
}

function getInvalidUpdatedISBNsForUser(uuid) {
  return Managers.license.getAllUnkeyedLicensesWithIndex('uuid', uuid).then(function(licenses) {
    var updatePromises = licenses.map(function(licenseObj) {
      return Managers.license.updateLicense(licenseObj.isbn, (licenseObj.authData && licenseObj.authData.productTypeId)).then(function(isUpdated) {
        return { isbn: licenseObj.isbn, isUpdated: isUpdated };
      });
    });
    return Promise.all(updatePromises).then(function(statuses) {
      var isbns = statuses
        .filter(function(status) {
          return !status.isUpdated;
        })
        .map(function(invalidStatus) {
          return invalidStatus.isbn;
        });
      return isbns;
    });
  });
}

// Public functions

Managers.ConfirmStoreDataValidity = function() {
  return Managers.user.getCurrentUser().then(function(user) {
    var uuid = user.bookvaultId;
    return getInvalidISBNsForUser(uuid)
      .then(function(isbns) {
        return removeInvalidStoreData(isbns);
      })
      .then(function() {
        return getInvalidUpdatedISBNsForUser(uuid);
      })
      .then(function(isbns) {
        return removeInvalidStoreData(isbns);
      });
  });
};

Managers.GetAllBookInfosForCurrentUser = function() {
  return Managers.user.getCurrentUser().then(function(user) {
    var uuid = user.bookvaultId;
    return Managers.library.getBookInfosWithIndex('uuid', uuid);
  });
};

Managers.RemoveDownloadedBook = function(isbn) {
  return removeInvalidStoreData([isbn]);
};

Managers.RemoveAllDownloadedBooks = function() {
  return Managers.user
    .getCurrentUser()
    .then(function(user) {
      var uuid = user.bookvaultId;
      return Managers.library.getBookInfosWithIndex('uuid', uuid).then(function(bookInfos) {
        var isbns = [];
        bookInfos.forEach(function(bookInfo) {
          if (bookInfo.downloaded) {
            isbns.push(bookInfo.isbn);
          }
        });

        return isbns;
      });
    })
    .then(function(isbns) {
      return removeInvalidStoreData(isbns);
    });
};

export default Managers;
